import axios from 'axios'
import { Message } from 'element-ui'
import loginUtil from '@xpeng/login-util'
import { getLocale } from '@xpeng/i18n'
import config from '@/config'
import CryptoJS from 'crypto-js' // 需要安装 crypto-js

// 创建axios实例
const ajax = axios.create({
  baseURL: '',
  timeout: 100 * 1000, // 请求超时时间 100s
  withCredentials: true // 允许跨域传递 cookie
})

const API_CODE = {
  SUCCESS: 200,
  UNLOGIN: 90310000,
  UNAUTHORIZATION: 4001009
}

// 配置参数
const urlSalt = '21323432'
const clientId = 'test'
const clientSecret = 'test'

// request拦截器
// 请求拦截器
ajax.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = getLocale()
    // Cookie初始化已移至src/utils/dev-cookie-init.js，仅在项目启动时执行一次

    // 生成时间戳（13位毫秒）
    const timestamp = Date.now().toString()

    // 准备签名参数
    const uri = config.url.replace('/vw-security-manage-boot', '') || ''
    const business = config.business || ''
    // 1. 处理 Body 参数 - 按照参数名字典序排列并拼接值
    let bodyStr = ''
    if (config.data) {
      if (typeof config.data === 'string') {
        try {
          // 如果是 JSON 字符串，先解析
          const dataObj = JSON.parse(config.data)
          bodyStr = generateBodyStr(dataObj)
        } catch (e) {
          // 如果不是 JSON，直接使用原字符串
          bodyStr = config.data
        }
      } else if (typeof config.data === 'object') {
        // 如果是对象
        bodyStr = generateBodyStr(config.data)
      }
    }
    // 2. 处理 Header 字符串
    const headerStr = clientId + clientSecret + business + timestamp
    // 3. 生成签名
    const signature = generateSignature(bodyStr, headerStr, uri, urlSalt)
    // 设置请求头
    config.headers = {
      ...config.headers,
      clientId: clientId,
      signature: signature,
      timestamp: timestamp,
      business: business
    }

    return config
  },
  (error) => {
    Message({
      message: 'HTTP请求出错',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

/**
 * 生成 Body 参数字符串（按照参数名字典序排列并拼接值）
 * @param {Object} data - 请求数据
 * @returns {string}
 */
function generateBodyStr(data) {
  if (!data || typeof data !== 'object') {
    return ''
  }

  // 按照键名排序
  const sortedKeys = Object.keys(data).sort()

  // 拼接所有值
  let bodyStr = ''
  sortedKeys.forEach((key) => {
    const value = data[key]
    if (value !== undefined && value !== null) {
      // 如果是数组，转换为带空格的方括号格式
      if (Array.isArray(value)) {
        const arrayStr =
          '[' + value.map((item) => String(item)).join(', ') + ']'
        bodyStr += arrayStr
      } else {
        bodyStr += String(value)
      }
    }
  })

  return bodyStr
}

/**
 * 生成签名
 * @param {string} bodyStr - Body 参数字符串
 * @param {string} headerStr - Header 字符串
 * @param {string} uri - 请求 URI
 * @param {string} salt - 盐值
 * @returns {string}
 */
function generateSignature(bodyStr, headerStr, uri, salt) {
  console.log(bodyStr)
  console.log(headerStr)
  console.log(uri)
  console.log(salt)
  const signStr = bodyStr + headerStr + uri + salt
  console.log('signStr', signStr)
  // 使用 SHA256 生成签名
  return CryptoJS.SHA256(signStr).toString(CryptoJS.enc.Hex)
}

// response 拦截器Accept-Language
ajax.interceptors.response.use(
  (response) => {
    if (response.data.code === API_CODE.UNLOGIN) {
      return loginUtil.redirectToLogin()
    } else if (response.data.code === API_CODE.UNAUTHORIZATION) {
      return loginUtil.redirectToAuthorization(config.PLATFORM_NAME, 1)
    }
    if (
      ['application/octet-stream'].indexOf(response.headers['content-type']) !==
      -1
    ) {
      return Promise.resolve(response)
    }
    return Promise.resolve(response.data)
  },
  (error) => {
    return Promise.reject(error.message || '服务器开小差')
  }
)

export default ajax
